import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const FILTER_KEY = 'quick_filter_simpleSize';

export const useQuickFilterSectionSizeSimpleOpenedState = () => {
  return useOpenedStateManager(FILTER_KEY);
};
